type OrderPrices = {
  percentageOff?: string | null
  totalDiscount?: string | null
}

export type DiscountTrackingProperties = {
  discountPercent: number
  amountSaved: number
  discountApplied: boolean
}

export const getDiscountTrackingProperties = (prices?: OrderPrices): DiscountTrackingProperties => {
  const discountPercent = parseFloat(prices?.percentageOff ?? '0')
  const amountSaved = parseFloat(prices?.totalDiscount ?? '0')

  return { discountPercent, amountSaved, discountApplied: discountPercent > 0 && amountSaved > 0 }
}
